import { cn } from '@/lib/cn'

/** The Taskly mark: a check inside the brand square. */
export function LogoMark({ className }: { className?: string }) {
  return (
    <span
      className={cn('flex size-7 shrink-0 items-center justify-center rounded-lg bg-brand-600', className)}
      aria-hidden="true"
    >
      <svg viewBox="0 0 32 32" className="size-4">
        <path
          d="M9 16.5l4.5 4.5L23 11.5"
          fill="none"
          stroke="#fff"
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  )
}

export function Wordmark({ className }: { className?: string }) {
  return (
    <span className={cn('flex items-center gap-2.5', className)}>
      <LogoMark />
      <span className="text-sm font-semibold tracking-tight">Taskly</span>
    </span>
  )
}
